import Pauta from '../components/Pauta';

export default function PautaFinanceiro() {
  return <Pauta statusPauta="Aguardando Financeiro" colunas={['NF-e', 'Boleto', 'Pgto NF', 'Pgto Custas']} corPauta="#0097a7" />;
}